import type { TaskTypeResponse } from '@erp/rpc';
import {
  editorStateFor,
  type TaskTypeDefaultAssigneeEditorState,
} from '@/pages/authenticated/settings/organization/components/cards/task-types/taskTypeAdmin';

/** A task type's saved default assignee, as the editor holds it. */
export function defaultAssigneeSlice(
  taskType: TaskTypeResponse,
): TaskTypeDefaultAssigneeEditorState {
  const editor = editorStateFor(taskType);
  return {
    defaultAssigneeMode: editor.defaultAssigneeMode,
    defaultAssigneeUserId: editor.defaultAssigneeUserId,
    defaultAssigneeAgentDefinitionId: editor.defaultAssigneeAgentDefinitionId,
    defaultAssigneeUserGroupId: editor.defaultAssigneeUserGroupId,
    defaultAssigneeWorkflowId: editor.defaultAssigneeWorkflowId,
    defaultAssigneeAllocation: editor.defaultAssigneeAllocation,
  };
}

export type AssigneeDrafts = Readonly<
  Record<string, TaskTypeDefaultAssigneeEditorState>
>;

/** The draft for a type, or its saved value when it hasn't been touched. */
export function assigneeDraftFor(
  taskType: TaskTypeResponse,
  drafts: AssigneeDrafts,
): TaskTypeDefaultAssigneeEditorState {
  return drafts[taskType.id] ?? defaultAssigneeSlice(taskType);
}

/** Types whose draft differs from what is saved: the ones Save writes. */
export function changedAssigneeDrafts(
  taskTypes: readonly TaskTypeResponse[],
  drafts: AssigneeDrafts,
): Array<{
  taskType: TaskTypeResponse;
  editor: TaskTypeDefaultAssigneeEditorState;
}> {
  return taskTypes.flatMap((taskType) => {
    const editor = drafts[taskType.id];
    const saved = JSON.stringify(defaultAssigneeSlice(taskType));
    return editor && JSON.stringify(editor) !== saved
      ? [{ taskType, editor }]
      : [];
  });
}
